export enum TransferType {
	DOC = 'DOC',
	TED = 'TED',
	ENTRE_CONTAS = 'ENTRE_CONTAS'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-other-banks/models/transferType.enum.ts